"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInfoAdministrationApi = exports.AppInfoAdministrationApiFactory = exports.AppInfoAdministrationApiFp = exports.AppInfoAdministrationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AppInfoAdministrationApi - axios parameter creator
 * @export
 */
const AppInfoAdministrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: ChangeAppCurrentAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın şu anki android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppCurrentAndroidVersionCommand} [changeAppCurrentAndroidVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppCurrentAndroidVersion: (changeAppCurrentAndroidVersionCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_app_current_android_version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeAppCurrentAndroidVersionCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeAppCurrentIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın şu anki ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppCurrentIosVersionCommand} [changeAppCurrentIosVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppCurrentIosVersion: (changeAppCurrentIosVersionCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_app_current_ios_version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeAppCurrentIosVersionCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeAppMaintenanceStatus - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın bakım durumunu değiştirmeyi sağlar. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMaintenanceStatusCommand} [changeAppMaintenanceStatusCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMaintenanceStatus: (changeAppMaintenanceStatusCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_app_maintenance_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeAppMaintenanceStatusCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeAppMinimumAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın minimum android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMinimumAndroidVersionCommand} [changeAppMinimumAndroidVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMinimumAndroidVersion: (changeAppMinimumAndroidVersionCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_app_minimum_android_version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeAppMinimumAndroidVersionCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeAppMinimumIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın minimum ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMinimumIosVersionCommand} [changeAppMinimumIosVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMinimumIosVersion: (changeAppMinimumIosVersionCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_app_minimum_ios_version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeAppMinimumIosVersionCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeDaysBetweenNonPremiumUsersAttendingLiveStreams - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayınlara girecek premium olmayan kullanıcıların kaç gün aralıkla canlı yayınlara ücretsiz girilebileceğini değiştirir.
         * @param {ChangeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand} [changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDaysBetweenNonPremiumUsersAttendingLiveStreams: (changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_days_between_non_premium_users_attending_live_streams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeFaq - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Faq maddelerinin değiştirilebilmesini sağlar
         * @param {ChangeFaqCommand} [changeFaqCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaq: (changeFaqCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_faq`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeFaqCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeIsBroadcastPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Broadcast push notificationlarının atılıp atılmayacağını belirler
         * @param {ChangeIsBroadcastPushNotificationsEnabledCommand} [changeIsBroadcastPushNotificationsEnabledCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIsBroadcastPushNotificationsEnabled: (changeIsBroadcastPushNotificationsEnabledCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_is_broadcast_push_notifications_enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeIsBroadcastPushNotificationsEnabledCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: ChangeIsSingleUserPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Single user push notificationlarının atılıp atılmayacağını belirler
         * @param {ChangeIsSingleUserPushNotificationsEnabledCommand} [changeIsSingleUserPushNotificationsEnabledCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIsSingleUserPushNotificationsEnabled: (changeIsSingleUserPushNotificationsEnabledCommand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/change_is_single_user_push_notifications_enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeIsSingleUserPushNotificationsEnabledCommand, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Operation Id: GetAppStatus - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Uygulamanın sürüm ve bakım bilgilerini getirir.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStatusForAdministration: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/app_info_administration/app_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AppInfoAdministrationApiAxiosParamCreator = AppInfoAdministrationApiAxiosParamCreator;
/**
 * AppInfoAdministrationApi - functional programming interface
 * @export
 */
const AppInfoAdministrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AppInfoAdministrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: ChangeAppCurrentAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın şu anki android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppCurrentAndroidVersionCommand} [changeAppCurrentAndroidVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppCurrentAndroidVersion(changeAppCurrentAndroidVersionCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeAppCurrentAndroidVersion(changeAppCurrentAndroidVersionCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeAppCurrentIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın şu anki ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppCurrentIosVersionCommand} [changeAppCurrentIosVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppCurrentIosVersion(changeAppCurrentIosVersionCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeAppCurrentIosVersion(changeAppCurrentIosVersionCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeAppMaintenanceStatus - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın bakım durumunu değiştirmeyi sağlar. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMaintenanceStatusCommand} [changeAppMaintenanceStatusCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMaintenanceStatus(changeAppMaintenanceStatusCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeAppMaintenanceStatus(changeAppMaintenanceStatusCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeAppMinimumAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın minimum android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMinimumAndroidVersionCommand} [changeAppMinimumAndroidVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMinimumAndroidVersion(changeAppMinimumAndroidVersionCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeAppMinimumAndroidVersion(changeAppMinimumAndroidVersionCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeAppMinimumIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın minimum ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMinimumIosVersionCommand} [changeAppMinimumIosVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMinimumIosVersion(changeAppMinimumIosVersionCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeAppMinimumIosVersion(changeAppMinimumIosVersionCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeDaysBetweenNonPremiumUsersAttendingLiveStreams - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayınlara girecek premium olmayan kullanıcıların kaç gün aralıkla canlı yayınlara ücretsiz girilebileceğini değiştirir.
         * @param {ChangeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand} [changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDaysBetweenNonPremiumUsersAttendingLiveStreams(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeDaysBetweenNonPremiumUsersAttendingLiveStreams(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeFaq - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Faq maddelerinin değiştirilebilmesini sağlar
         * @param {ChangeFaqCommand} [changeFaqCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaq(changeFaqCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeFaq(changeFaqCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeIsBroadcastPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Broadcast push notificationlarının atılıp atılmayacağını belirler
         * @param {ChangeIsBroadcastPushNotificationsEnabledCommand} [changeIsBroadcastPushNotificationsEnabledCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIsBroadcastPushNotificationsEnabled(changeIsBroadcastPushNotificationsEnabledCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeIsBroadcastPushNotificationsEnabled(changeIsBroadcastPushNotificationsEnabledCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: ChangeIsSingleUserPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Single user push notificationlarının atılıp atılmayacağını belirler
         * @param {ChangeIsSingleUserPushNotificationsEnabledCommand} [changeIsSingleUserPushNotificationsEnabledCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIsSingleUserPushNotificationsEnabled(changeIsSingleUserPushNotificationsEnabledCommand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeIsSingleUserPushNotificationsEnabled(changeIsSingleUserPushNotificationsEnabledCommand, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Operation Id: GetAppStatus - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Uygulamanın sürüm ve bakım bilgilerini getirir.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStatusForAdministration(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppStatusForAdministration(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AppInfoAdministrationApiFp = AppInfoAdministrationApiFp;
/**
 * AppInfoAdministrationApi - factory interface
 * @export
 */
const AppInfoAdministrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AppInfoAdministrationApiFp)(configuration);
    return {
        /**
         * Operation Id: ChangeAppCurrentAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın şu anki android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppCurrentAndroidVersionCommand} [changeAppCurrentAndroidVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppCurrentAndroidVersion(changeAppCurrentAndroidVersionCommand, options) {
            return localVarFp.changeAppCurrentAndroidVersion(changeAppCurrentAndroidVersionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeAppCurrentIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın şu anki ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppCurrentIosVersionCommand} [changeAppCurrentIosVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppCurrentIosVersion(changeAppCurrentIosVersionCommand, options) {
            return localVarFp.changeAppCurrentIosVersion(changeAppCurrentIosVersionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeAppMaintenanceStatus - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın bakım durumunu değiştirmeyi sağlar. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMaintenanceStatusCommand} [changeAppMaintenanceStatusCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMaintenanceStatus(changeAppMaintenanceStatusCommand, options) {
            return localVarFp.changeAppMaintenanceStatus(changeAppMaintenanceStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeAppMinimumAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın minimum android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMinimumAndroidVersionCommand} [changeAppMinimumAndroidVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMinimumAndroidVersion(changeAppMinimumAndroidVersionCommand, options) {
            return localVarFp.changeAppMinimumAndroidVersion(changeAppMinimumAndroidVersionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeAppMinimumIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamanın minimum ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
         * @param {ChangeAppMinimumIosVersionCommand} [changeAppMinimumIosVersionCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeAppMinimumIosVersion(changeAppMinimumIosVersionCommand, options) {
            return localVarFp.changeAppMinimumIosVersion(changeAppMinimumIosVersionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeDaysBetweenNonPremiumUsersAttendingLiveStreams - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Canlı yayınlara girecek premium olmayan kullanıcıların kaç gün aralıkla canlı yayınlara ücretsiz girilebileceğini değiştirir.
         * @param {ChangeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand} [changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDaysBetweenNonPremiumUsersAttendingLiveStreams(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options) {
            return localVarFp.changeDaysBetweenNonPremiumUsersAttendingLiveStreams(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeFaq - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Faq maddelerinin değiştirilebilmesini sağlar
         * @param {ChangeFaqCommand} [changeFaqCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFaq(changeFaqCommand, options) {
            return localVarFp.changeFaq(changeFaqCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeIsBroadcastPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Broadcast push notificationlarının atılıp atılmayacağını belirler
         * @param {ChangeIsBroadcastPushNotificationsEnabledCommand} [changeIsBroadcastPushNotificationsEnabledCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIsBroadcastPushNotificationsEnabled(changeIsBroadcastPushNotificationsEnabledCommand, options) {
            return localVarFp.changeIsBroadcastPushNotificationsEnabled(changeIsBroadcastPushNotificationsEnabledCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: ChangeIsSingleUserPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Single user push notificationlarının atılıp atılmayacağını belirler
         * @param {ChangeIsSingleUserPushNotificationsEnabledCommand} [changeIsSingleUserPushNotificationsEnabledCommand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeIsSingleUserPushNotificationsEnabled(changeIsSingleUserPushNotificationsEnabledCommand, options) {
            return localVarFp.changeIsSingleUserPushNotificationsEnabled(changeIsSingleUserPushNotificationsEnabledCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Operation Id: GetAppStatus - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
         * @summary Uygulamanın sürüm ve bakım bilgilerini getirir.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStatusForAdministration(options) {
            return localVarFp.getAppStatusForAdministration(options).then((request) => request(axios, basePath));
        },
    };
};
exports.AppInfoAdministrationApiFactory = AppInfoAdministrationApiFactory;
/**
 * AppInfoAdministrationApi - object-oriented interface
 * @export
 * @class AppInfoAdministrationApi
 * @extends {BaseAPI}
 */
class AppInfoAdministrationApi extends base_1.BaseAPI {
    /**
     * Operation Id: ChangeAppCurrentAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Uygulamanın şu anki android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
     * @param {ChangeAppCurrentAndroidVersionCommand} [changeAppCurrentAndroidVersionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeAppCurrentAndroidVersion(changeAppCurrentAndroidVersionCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeAppCurrentAndroidVersion(changeAppCurrentAndroidVersionCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeAppCurrentIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Uygulamanın şu anki ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
     * @param {ChangeAppCurrentIosVersionCommand} [changeAppCurrentIosVersionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeAppCurrentIosVersion(changeAppCurrentIosVersionCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeAppCurrentIosVersion(changeAppCurrentIosVersionCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeAppMaintenanceStatus - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Uygulamanın bakım durumunu değiştirmeyi sağlar. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
     * @param {ChangeAppMaintenanceStatusCommand} [changeAppMaintenanceStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeAppMaintenanceStatus(changeAppMaintenanceStatusCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeAppMaintenanceStatus(changeAppMaintenanceStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeAppMinimumAndroidVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Uygulamanın minimum android versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
     * @param {ChangeAppMinimumAndroidVersionCommand} [changeAppMinimumAndroidVersionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeAppMinimumAndroidVersion(changeAppMinimumAndroidVersionCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeAppMinimumAndroidVersion(changeAppMinimumAndroidVersionCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeAppMinimumIosVersion - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Uygulamanın minimum ios versiyonunu değiştirir. @CacheEvict(\"appinfo\") handler metodu üzerine yazılarak cache temizlenmelidir.
     * @param {ChangeAppMinimumIosVersionCommand} [changeAppMinimumIosVersionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeAppMinimumIosVersion(changeAppMinimumIosVersionCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeAppMinimumIosVersion(changeAppMinimumIosVersionCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeDaysBetweenNonPremiumUsersAttendingLiveStreams - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Canlı yayınlara girecek premium olmayan kullanıcıların kaç gün aralıkla canlı yayınlara ücretsiz girilebileceğini değiştirir.
     * @param {ChangeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand} [changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeDaysBetweenNonPremiumUsersAttendingLiveStreams(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeDaysBetweenNonPremiumUsersAttendingLiveStreams(changeDaysBetweenNonPremiumUsersAttendingLiveStreamsCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeFaq - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Faq maddelerinin değiştirilebilmesini sağlar
     * @param {ChangeFaqCommand} [changeFaqCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeFaq(changeFaqCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeFaq(changeFaqCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeIsBroadcastPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Broadcast push notificationlarının atılıp atılmayacağını belirler
     * @param {ChangeIsBroadcastPushNotificationsEnabledCommand} [changeIsBroadcastPushNotificationsEnabledCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeIsBroadcastPushNotificationsEnabled(changeIsBroadcastPushNotificationsEnabledCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeIsBroadcastPushNotificationsEnabled(changeIsBroadcastPushNotificationsEnabledCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: ChangeIsSingleUserPushNotificationsEnabled - Difficulty: 1 - Roles can execute: ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Single user push notificationlarının atılıp atılmayacağını belirler
     * @param {ChangeIsSingleUserPushNotificationsEnabledCommand} [changeIsSingleUserPushNotificationsEnabledCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    changeIsSingleUserPushNotificationsEnabled(changeIsSingleUserPushNotificationsEnabledCommand, options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).changeIsSingleUserPushNotificationsEnabled(changeIsSingleUserPushNotificationsEnabledCommand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Operation Id: GetAppStatus - Difficulty: 4 - Roles can execute: ROLE_ADMIN, ROLE_SUPER_ADMIN
     * @summary Uygulamanın sürüm ve bakım bilgilerini getirir.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppInfoAdministrationApi
     */
    getAppStatusForAdministration(options) {
        return (0, exports.AppInfoAdministrationApiFp)(this.configuration).getAppStatusForAdministration(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AppInfoAdministrationApi = AppInfoAdministrationApi;
